import { CreditTier, FinalPlan, PlanData, PlanPeriod } from './PlanTypes';

/**
 * Determines if a plan change is a downgrade by comparing billing amounts
 * @param currentBillingAmount - The current subscription billing amount
 * @param newPlan - The new plan to change to
 * @param selectedPeriod - The selected billing period
 * @param addOnPlanCodeSelected - Optional addon plan code to include in price calculation
 * @returns true if downgrade, false if upgrade or same price
 */
export const isPlanDowngrade = (
    currentBillingAmount: number | null | undefined,
    newPlan: (PlanData | FinalPlan) | null,
    selectedPeriod: PlanPeriod,
    addOnPlanCodeSelected?: string,
): boolean => {
    if (!currentBillingAmount || !newPlan) {
        return false;
    }

    // Calculate new total price (base plan + addon if selected)
    const basePlanPrice = (newPlan.pricing[selectedPeriod] || 0) * (selectedPeriod === 'annual' ? 12 : 1);

    let addOnsPrice = 0;
    let selectedCreditTier: CreditTier | undefined = undefined;
    if (addOnPlanCodeSelected && 'creditTiers' in newPlan && newPlan.creditTiers) {
        selectedCreditTier = newPlan.creditTiers.find((tier) => {
            const periodPlanCode = selectedPeriod === 'monthly' ? tier.monthlyPlanCode : tier.annualPlanCode;
            return periodPlanCode === addOnPlanCodeSelected;
        });

        if (selectedCreditTier) {
            addOnsPrice = selectedCreditTier.additionalCost || 0;
        }
    }

    const newPrice = basePlanPrice + addOnsPrice * (selectedPeriod === 'monthly' ? 1 : 12);

    return newPrice < currentBillingAmount;
};
